module.exports = __webpack_public_path__ + "img/program.b23392cb.png";